import { OpmeBundle, ProcedimentoBundle, Referencia } from "../../types/resources.types";

// Texto da fundamentação técnica do recurso, montado a partir das referências devolvidas pelo backend.
// helpers
const safe = (v?: string) => (v ? String(v).trim() : "");

function formatReferencia(ref: Referencia, idx: number) {
  // Ex: Smith et al. (2023). "Título" Fonte.
  const autores = safe(ref.autores);
  const ano = safe(ref.ano);
  const titulo = safe(ref.titulo);
  const fonte = safe(ref.fonte);

  const linha1 =
    `${idx}. ` +
    `${autores ? autores : "Autor(es)"}${ano ? ` (${ano})` : ""}. ` +
    `"${titulo || "Título"}"` +
    `${fonte ? `. ${fonte}.` : "."}`;

  const resumo = safe(ref.resumo) ? `\nResumo: ${ref.resumo}` : "";

  // bloco 3 linhas (bonito pra copiar/exportar)
  return [linha1, resumo].filter(Boolean).join("\n");
}

function buildProcedimentoBlock(proc: ProcedimentoBundle): string {
  const blocks: string[] = [];

  const nome = safe(proc.nome) || "Procedimento";
  const justificativa = safe(proc.justificativa_relacao_com_caso);

  blocks.push(`A indicação do procedimento ${nome} é respaldada pela literatura médica:`);

  if (justificativa) {
    blocks.push(justificativa);
    blocks.push("\n");
  }

  const refs = proc.referencias ?? [];

  if (!refs.length) {
    blocks.push("Nenhuma referência bibliográfica cadastrada para este procedimento.");
    return blocks.join("\n");
  }

  refs.forEach((ref, idx) => {
    blocks.push(formatReferencia(ref, idx + 1));
    blocks.push("");
  });

  return blocks.join("\n").trim();
}

function buildOpmeBlock(opme: OpmeBundle): string {
  const blocks: string[] = [];

  const nome = safe(opme.nome) || "Material / OPME";
  const justificativa = safe(opme.justificativa_relacao_com_caso);

  blocks.push(`A indicação do material ${nome} é tecnicamente justificada e respaldada por referências:`);

  if (justificativa) {
    blocks.push(justificativa);
    blocks.push("\n");
  }

  const refs = opme.referencias ?? [];

  if (!refs.length) {
    blocks.push("Nenhuma referência bibliográfica cadastrada para este material.");
    return blocks.join("\n");
  }

  refs.forEach((ref, idx) => {
    blocks.push(formatReferencia(ref, idx + 1));
    blocks.push("");
  });

  return blocks.join("\n").trim();
}

export function generateFundTecTexto(
  procedimentosBundles: ProcedimentoBundle[],
  opmesBundles: OpmeBundle[]
): string {
  const blocks: string[] = [];

  // =========================
  // PROCEDIMENTOS CIRÚRGICOS
  // =========================
  if (procedimentosBundles.length) {
    blocks.push("FUNDAMENTAÇÃO TÉCNICA – PROCEDIMENTOS CIRÚRGICOS");
    blocks.push("\n");

    procedimentosBundles.forEach((proc) => {
      blocks.push(buildProcedimentoBlock(proc));
      blocks.push(""); // espaço entre procedimentos
    });
  }

  // =========================
  // MATERIAIS / OPME
  // =========================
  if (opmesBundles.length) {
    if (blocks.length) blocks.push(""); // espaço entre seções

    blocks.push("FUNDAMENTAÇÃO TÉCNICA – MATERIAIS / OPME");
    blocks.push("\n");

    opmesBundles.forEach((opme) => {
      blocks.push(buildOpmeBlock(opme));
      blocks.push(""); // espaço entre opmes
    });
  }

  return blocks.join("\n").trim();
}
